import * as React from 'react';
import { SVGProps } from 'react';

const IconSearchStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.453 8.16a4 4 0 1 1 .707-.707l2.844 2.844-.707.707L7.453 8.16ZM8 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
  </svg>
);
export default IconSearchStrokedSizeXs;
